// material-ui
import { useColorScheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';

// project imports
import Search from './Search';
import Profile from './Profile';
import Notification from './Notification';
import MobileSection from './MobileSection';

// assets
import MoonOutlined from '@ant-design/icons/MoonOutlined';
import SunOutlined from '@ant-design/icons/SunOutlined';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const { mode, setMode } = useColorScheme();
  const activeMode = mode || 'dark';
  const isDark = activeMode === 'dark';

  const handleThemeModeToggle = () => {
    setMode(isDark ? 'light' : 'dark');
  };

  return (
    <>
      {!downLG && <Search />}
      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}
      <Tooltip title={isDark ? '라이트 모드로 전환' : '다크 모드로 전환'}>
        <IconButton
          onClick={handleThemeModeToggle}
          disableRipple
          color="secondary"
          aria-label={isDark ? '라이트 모드로 전환' : '다크 모드로 전환'}
          sx={{
            color: 'text.primary',
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            '&:hover': { bgcolor: 'action.hover' }
          }}
        >
          {isDark ? <SunOutlined /> : <MoonOutlined />}
        </IconButton>
      </Tooltip>

      <Notification />
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
}
